import type { ResolvedMonospaceSpace } from '#layers/data-model/public';
import { validateWorkspaceSpaceRoutes } from '#layers/spaces/public';
import { createSpaceRoutes } from './space-routes';

/**
 * Builds and validates the space routes of a prepared workspace.
 *
 * `space.pages` resolves from the cache, so call it only once `workspacePagesHydration` has settled.
 */
export function prepareWorkspaceSpaceRoutes(spaces: ResolvedMonospaceSpace[]) {
	const routes = createSpaceRoutes({ spaces });
	validateWorkspaceSpaceRoutes(routes);
	return routes;
}
